<template>
  <div :class="s.wrapper">
    <div :class="s.title">ログインの承認</div>

    <div :class="s.panel">
      <p v-if="isLoading">読み込み中です…</p>

      <!-- 承認待ち: 内容を確認して承認する -->
      <template v-else-if="info.state === 'pending'">
        <p>次のログインの要求を承認しますか？</p>
        <dl :class="s.detail">
          <dt>アカウント</dt><dd>{{ info.loginId }}</dd>
          <dt>日時</dt><dd>{{ info.requestedAt }}</dd>
          <dt>IPアドレス</dt><dd>{{ info.requestIp || '不明' }}</dd>
          <dt>ブラウザ</dt><dd>{{ info.browser }}</dd>
        </dl>
        <p :class="s.warning">心当たりがない場合は承認せず、管理者に連絡してください。</p>
        <button
          type="button"
          :class="s.button"
          :disabled="isApproving"
          @click="approve">承認する</button>
        <p v-if="errorMessage" :class="s.error">{{ errorMessage }}</p>
      </template>

      <!-- 承認済み -->
      <template v-else-if="info.state === 'approved'">
        <p :class="s.done">承認しました</p>
        <p>ログインを要求した画面に戻ってください。数秒でログインします。<br />この画面は閉じてかまいません。</p>
      </template>

      <p v-else-if="info.state === 'consumed'">このログインはすでに完了しています。</p>

      <p v-else-if="info.state === 'expired'" :class="s.error">
        承認の有効期限が切れています。<br />ログイン画面で最初からやり直してください。
      </p>

      <p v-else :class="s.error">
        このURLは使えません。<br />再送した場合は、新しいメールのURLを開いてください。
      </p>
    </div>
  </div>
</template>

<script>
/**
 * ログインの承認画面（メール承認の2段階認証 #3917）
 * 承認メールのURL（/login/approve?key=承認キー）から開く。ログイン不要
 * 開いただけでは承認しない（メールのセキュリティ製品がURLを先に開くことがあるため）
 */
export default {
  name: 'LoginApprove',
  data() {
    return {
      isLoading: true,
      isApproving: false,
      errorMessage: '',
      info: { state: null },
    };
  },
  computed: {
    approveKey() {
      return this.$route.query?.key || '';
    },
  },
  created() {
    this.getInfo();
  },
  methods: {
    /** 承認画面に出す内容を取得する（承認はしない） */
    getInfo() {
      this.isLoading = true;
      this.axios({
        method: 'post',
        url: '/v1/user/login/2fa/approveInfo',
        data: { key: this.approveKey },
      })
        .then((response) => {
          this.info = response.data;
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
          this.info = { state: 'invalid' };
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    approve() {
      this.isApproving = true;
      this.errorMessage = '';
      this.axios({
        method: 'post',
        url: '/v1/user/login/2fa/approve',
        data: { key: this.approveKey },
      })
        .then((response) => {
          this.info = { ...this.info, state: response.data.state };
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
          this.errorMessage = '承認できませんでした。時間をおいて再度お試しください。';
        })
        .finally(() => {
          this.isApproving = false;
        });
    },
  },
};
</script>

<style lang="scss" module="s">
.wrapper {
  padding: calc(var(--header-height) + 24px) 24px 80px;
  max-width: 560px;
  margin: 0 auto;
  @include mdView {
    padding-top: calc(var(--md-header-height) + 24px);
  }
}
.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 24px;
}
.panel {
  padding: 24px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  line-height: 1.8;
}
.detail {
  display: grid;
  grid-template-columns: 7em 1fr;
  row-gap: 4px;
  margin: 16px 0;

  > dt {
    color: #667085;
  }

  > dd {
    margin: 0;
    word-break: break-all;
  }
}
.warning {
  margin-bottom: 16px;
  color: #d92d20;
  font-size: 14px;
}
.button {
  width: 100%;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  background-color: var(--theme-blue);
  color: #ffffff;
  font-weight: bold;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
}
.done {
  font-weight: bold;
  margin-bottom: 8px;
}
.error {
  color: #d92d20;
  margin-top: 8px;
}
</style>
